// Ensure the experiment has year_month in it to avoid future collision
// Note: The _20 is there to get types working, just `${number}` does not work
type ApiABExperimentIdFormat = `${string}_20${number}_${number}`;

type ApiABExperimentDefinition<TBucket extends string> = {
  buckets: TBucket[];
  defaultBucket: TBucket;
};

// List of AB experiments
export const apiABExperiments = {
  // This is an old experiment, please do not add new experiments that don't have _year_month on their ids
  [`OLD_CART_MIGRATION` as ApiABExperimentIdFormat]: {
    buckets: ['OLD', 'NEW'] as string[],
    defaultBucket: 'NEW',
  } as const,
  VOLOP_DETAILS_SEARCH_SIDEBAR_2025_11: {
    buckets: ['DISABLED', 'ENABLED'] as string[],
    defaultBucket: 'DISABLED',
  },
  RENEW_VOLOPS_2026_01: {
    buckets: ['DISABLED', 'ENABLED'] as string[],
    defaultBucket: 'DISABLED',
  },
} satisfies Record<ApiABExperimentIdFormat, ApiABExperimentDefinition<string>>;
